import { FORMAT, formatDateTime } from '../../helpers/datetime'
import { formatText, valToPercent } from '../../helpers/value'

export const mapTableOfOwnershipStructure = {
  id: {
    key: 'id',
    title: 'companyAnalysis.ownershipAndGroup.ID',
    thStyle: { textAlign: 'left' },
    parentThStyle: {
      width: 50,
    },
    format: (val) => val,
  },
  ownershipName: {
    key: 'ownershipName',
    title: 'companyAnalysis.ownershipAndGroup.NAME',
    thStyle: { textAlign: 'left' },
    parentThStyle: {
      width: 350,
    },
    sortable: true,
    format: (val) => formatText(val),
  },
  ownershipType: {
    key: 'ownershipType',
    title: 'companyAnalysis.ownershipAndGroup.TYPE',
    thStyle: { textAlign: 'left' },
    parentThStyle: {
      width: 150,
    },
    format: (val) => formatText(val),
  },
  percentage: {
    key: 'percentage',
    title: 'companyAnalysis.ownershipAndGroup.PERCENTAGE',
    thStyle: { justifyContent: 'flex-end', textAlign: 'right' },
    parentThStyle: {
      width: 100,
    },
    format: (val, locale) => valToPercent(val, locale),
  },
  country: {
    key: 'country',
    title: 'companyAnalysis.ownershipAndGroup.COUNTRY',
    thStyle: { textAlign: 'left' },
    parentThStyle: {
      width: 150,
    },
    format: (val) => formatText(val),
  },
  taxCode: {
    key: 'taxCode',
    title: 'companyAnalysis.ownershipAndGroup.TAX_CODE',
    thStyle: { textAlign: 'left' },
    parentThStyle: {
      width: 150,
    },
    format: (val) => formatText(val),
  },
  publicDateId: {
    key: 'publicDateId',
    title: 'companyAnalysis.ownershipAndGroup.PUBLICATION_DATE',
    thStyle: { textAlign: 'left' },
    sortable: true,
    format: (val, locale) => formatDateTime(val, FORMAT.MONTH_YEAR, locale),
  },
}

export const mapTableOfRelatedCompanies = {
  id: {
    key: 'id',
    title: () => 'companyAnalysis.ownershipAndGroup.ID',
    thStyle: { textAlign: 'left' },
  },
  organizationName: {
    key: 'organizationName',
    title: () => 'companyAnalysis.ownershipAndGroup.COMPANY_NAME',
    thStyle: { textAlign: 'left' },
  },
  status: {
    key: 'status',
    title: (isResponsive) =>
      isResponsive
        ? 'companyAnalysis.ownershipAndGroup.STATUS_RES'
        : 'companyAnalysis.ownershipAndGroup.STATUS',
    thStyle: { textAlign: 'left' },
  },
  address: {
    key: 'address',
    title: () => 'companyAnalysis.ownershipAndGroup.ADDRESS',
    thStyle: { textAlign: 'left' },
  },
  relationshipGroup: {
    key: 'relationshipGroup',
    title: () => 'companyAnalysis.ownershipAndGroup.RELATIONSHIP',
    thStyle: { textAlign: 'left' },
  },
}

export const mapTableOfOthers = {
  id: {
    key: 'id',
    title: 'companyAnalysis.ownershipAndGroup.ID',
    thStyle: { textAlign: 'left' },
    parentThStyle: {
      width: 50,
    },
    format: (val) => val,
  },
  organizationName: {
    key: 'organizationName',
    title: 'companyAnalysis.ownershipAndGroup.COMPANY_NAME',
    thStyle: { textAlign: 'left' },
    parentThStyle: {
      width: 500,
    },
    format: (val) => formatText(val),
  },
  percentage: {
    key: 'percentage',
    title: 'companyAnalysis.ownershipAndGroup.PERCENTAGE',
    thStyle: {
      justifyContent: 'flex-end',
      textAlign: 'right',
    },
    parentThStyle: {
      width: 100,
    },
    format: (val, locale) => valToPercent(val, locale),
  },
  taxCode: {
    key: 'taxCode',
    title: 'companyAnalysis.ownershipAndGroup.TAX_CODE',
    thStyle: { textAlign: 'left' },
    parentThStyle: {
      width: 150,
    },
    format: (val) => formatText(val),
  },
  address: {
    key: 'address',
    title: 'companyAnalysis.ownershipAndGroup.ADDRESS',
    thStyle: { textAlign: 'left' },
    format: (val) => formatText(val),
  },
}

export const mapTableOfBranches = {
  id: {
    key: 'id',
    title: 'companyAnalysis.ownershipAndGroup.ID',
    thStyle: { textAlign: 'left' },
    parentThStyle: {
      width: 50,
    },
    format: (val) => val,
  },
  organizationName: {
    key: 'organizationName',
    title: 'companyAnalysis.ownershipAndGroup.COMPANY_NAME',
    thStyle: { textAlign: 'left' },
    parentThStyle: {
      width: 600,
    },
    childTdStyle: {
      width: 500,
    },
    format: (val) => formatText(val),
  },
  taxCode: {
    key: 'taxCode',
    title: 'companyAnalysis.ownershipAndGroup.TAX_CODE',
    thStyle: { textAlign: 'left' },
    parentThStyle: {
      width: 150,
    },
    format: (val) => formatText(val),
  },
  address: {
    key: 'address',
    title: 'companyAnalysis.ownershipAndGroup.ADDRESS',
    thStyle: { textAlign: 'left' },
    format: (val) => formatText(val),
  },
}
